import { DELETION_REASON_FIELDS } from 'routes/App/JobsAdmin/Jobs/JobWorkflowForm/constants'

export type DeletionReasonFieldProps = {
  onChangeDeletionReasonFieldValue: (
    value: Record<string, string> | null,
  ) => void
  deletionReasons?: string[]
  deletionReasonType: DELETION_REASON_FIELDS
}

export interface ConditionalInputs {
  available: number[]
  hidden: number[]
}

export interface PopulatedEvtInput {
  id: number
  input: number
  result: boolean | string | number | string[]
}

export interface ConditionalItems {
  inputs: ConditionalInputs
  inputGroups: ConditionalInputs
  populatedEvtInputs?: PopulatedEvtInput[]
  clearedConditionalEvtInputIds?: number[]
  clearedPopulatedEvtInputIds?: number[]
}

export interface EvtInput {
  id: number
  input: number
  result: boolean | string | number | string[] | null
  uuid: string
  conditionalItems?: ConditionalItems
}

export interface PopulateLogic {
  uuid?: string
  operator: string
  conditions: {
    criteria: string
    input: number
    input_uuid: string
    values: (boolean | string)[]
  }[]
  inputs: number[]
  population_values?: Record<string, string>
}

export interface Parameters {
  conditional_logic_dependency?: boolean
  display_options?: string
  multiple?: boolean
  conditional_logic?: {
    operator: string
    conditions: {
      criteria: string
      input: number
      input_uuid: string
      values: (boolean | string)[]
    }[]
  }
  populate_logic?: PopulateLogic
}

export enum CONDITIONAL_ITEM_TYPE {
  INPUT_GROUPS = 'inputGroups',
  INPUTS = 'inputs',
}
